import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import addIcon from "svg/add.svg";
import deleteIconBlue from "svg/delete_blue.svg";
import ProductLookup from "common/productLookup";
import { getlaborCodeOptions } from "store/siteRepo/actionCreator";
import Confirmation from "./confirmation";
import Select from "react-select";
import { isEmpty, omit, uniqBy } from "lodash";
import RerunBulkUpdate from "./RerunBulkUpdate";
import ProductDisplay from "./ProductDisplay";
import "./style.scss";

const BulkUpdateSite = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { siteId } = useParams();

  const [stage, setStage] = useState("product");
  const [productsData, setProductsData] = useState([]);
  const [isShowAddProductModal, setIsShowAddProductModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [isAddingNewProduct, setIsAddingNewProduct] = useState(false);

  const { terrCcn, storeCcn } = useSelector((state) => state.loggedInUser);
  const { viewSite, distinctLaborCodes, stores } = useSelector((state) => state.siteRepo);

  const { projectDetailsList, territory, storeNumber } = viewSite;

  useEffect(() => {
    if (!distinctLaborCodes?.length) dispatch(getlaborCodeOptions());
  }, []);

  useEffect(() => {
    let products = (projectDetailsList ?? [])
      .flatMap((proj) => proj?.layerInfoList ?? [])
      .flatMap((layer) => layer?.rooms ?? [])
      .flatMap((room) => room?.products ?? []);

    setProductsData(uniqBy(products, "id").map((e) => ({ ...e, laborCodesArr: [] })));
  }, [projectDetailsList]);

  const onProductLookup = (product, isShow, isAddingNewProduct) => {
    setIsShowAddProductModal(isShow);
    setSelectedProduct(product);
    setIsAddingNewProduct(isAddingNewProduct);
  };

  const onProductSelection = (product) => {
    if (isAddingNewProduct) {
      const newProduct = {
        newProductId: product.productName,
        newType: product.category,
        newSalesNumber: product.salesNumber,
        newCategoryCode: product.categoryCode,
        id: product.productName,
        type: product.category,
        salesNumber: product.salesNumber,
        categoryCode: product.categoryCode,
        actualUsage: "0",
        isManualProduct: true,
        laborCodesArr: [],
      };
      setProductsData([...productsData.filter((p) => p.salesNumber != product.salesNumber), newProduct]);
    } else {
      setProductsData(
        productsData.map((p) =>
          p.roomInfoId === selectedProduct.roomInfoId
            ? {
                ...p,
                newProductId: product.productName,
                newType: product.category,
                newSalesNumber: product.salesNumber,
                newCategoryCode: product.categoryCode,
              }
            : p,
        ),
      );
      setSelectedProduct(selectedProduct);
    }
    setIsShowAddProductModal(false);
  };

  if (stage === "confirmation") {
    return <Confirmation productsData={productsData} setStage={setStage} />;
  }

  const anyNewProducts = productsData.some((p) => !isEmpty(p.newProductId));
  const anyNewLaborCodes = productsData.some((p) => !isEmpty(p.laborCodesArr));
  const nextDisabled = !anyNewProducts && !anyNewLaborCodes;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-4 mb-2 border rounded">
        <span className="search-form-container__title--text">Bulk Update Site</span>
        {((territory === terrCcn && territory !== "800100") || storeCcn === storeNumber) && (
          <div className="d-flex justify-content-end">
            <Button variant="outline-primary" onClick={() => onProductLookup("", true, true)}>
              Add New Product
            </Button>
            <RerunBulkUpdate productsData={productsData} setProductsData={setProductsData} />
          </div>
        )}
      </div>

      {productsData.map((product, index) => (
        <div
          key={index + product?.categoryCode + product?.roomInfoId}
          className="product-view bulk-product-container bg-light"
        >
          <div className="d-flex">
            {!product.isManualProduct && (
              <div className="border rounded p-2 m-2 bg-white" style={{ width: "calc(50% - 16px)" }}>
                <div className="d-flex item-header mb-2">Current Product</div>
                <ProductDisplay number={product?.salesNumber} name={product?.id} category={product?.type} />
              </div>
            )}
            {product.newSalesNumber ? (
              <div className="border rounded p-2 m-2 bg-white" style={{ width: "calc(50% - 16px)" }}>
                <div className="d-flex item-header mb-2">
                  <span className="highlight">{product.isManualProduct ? "New" : "Replacement"} Product</span>
                  <img
                    src={deleteIconBlue}
                    alt="delete"
                    className="del-icon"
                    onClick={() => {
                      if (product.isManualProduct) {
                        setProductsData(productsData.filter((ele) => ele.newProductId !== product.newProductId));
                      } else {
                        setProductsData(
                          productsData.map((element) =>
                            element.roomInfoId === product.roomInfoId
                              ? omit(element, ["newProductId", "newType", "newSalesNumber", "newCategoryCode"])
                              : element,
                          ),
                        );
                      }
                    }}
                  />
                </div>
                <ProductDisplay
                  number={product?.newSalesNumber}
                  name={product?.newProductId}
                  category={product?.newType}
                />
              </div>
            ) : (
              <Button
                variant="link"
                className="text-decoration-none"
                onClick={() => onProductLookup(product, true, false)}
              >
                Add Replacement Product
              </Button>
            )}
          </div>
          <div className="labor-codes-container d-flex w-100 flex-column ml-5">
            <Button
              variant="light"
              className={`ms-5 rounded-0 labor-codes-header ${product.laborCodesArr?.length ? "exists" : "empty mb-2"}`}
              onClick={() =>
                setProductsData(
                  productsData.map((p) => (p.id === product.id ? { ...p, isShowAddLaborCodes: true } : p)),
                )
              }
            >
              <img src={addIcon} alt="" className="labor-codes-header-icon" />
              Labor Codes
            </Button>
            {product.isShowAddLaborCodes && (
              <div className="d-flex my-2 ms-5" style={{ width: 600 }}>
                <Select
                  className="me-2 flex-grow-1"
                  options={(distinctLaborCodes ?? [])
                    .filter((lc) => !product.selectedLaborCodes?.includes(lc.laborCode))
                    .map((lc) => ({ value: lc.id, label: `${lc.laborCode} - ${lc.description}`, ...lc }))}
                  placeholder="Select any labor code"
                  onChange={(lc) => {
                    const storeLaborCodes = stores[viewSite.storeNumber]?.laborCodes;
                    const newLaborCode = {
                      ...lc,
                      isTaxable: storeLaborCodes?.find((lc) => lc.laborCodeId === Number(lc.id))?.isTaxable,
                    };
                    setProductsData(
                      productsData.map((p) =>
                        p.id === product.id
                          ? {
                              ...p,
                              laborCodesArr: [...p.laborCodesArr, newLaborCode],
                              selectedLaborCodes: [...(p.selectedLaborCodes || []), lc.laborCode],
                              isShowAddLaborCodes: false,
                            }
                          : p,
                      ),
                    );
                  }}
                  autoFocus
                  defaultMenuIsOpen
                />
                <Button
                  variant="outline-primary"
                  onClick={() =>
                    setProductsData(
                      productsData.map((p) => (p.id === product.id ? { ...p, isShowAddLaborCodes: false } : p)),
                    )
                  }
                >
                  Cancel
                </Button>
              </div>
            )}
            {product?.laborCodesArr?.map((laborCodeItem, itemIndex) => (
              <div
                className="d-flex align-items-center py-2 ms-5"
                key={itemIndex + laborCodeItem.id}
                style={{ borderBottom: "1px solid #d1d1d1", marginBottom: -1, width: "fit-content" }}
              >
                <div className="pe-2" style={{ borderRight: "1px solid #d1d1d1", width: 40 }}>
                  {laborCodeItem.laborCode}
                </div>
                <div className="px-2" style={{ borderRight: "1px solid #d1d1d1", width: 450 }}>
                  {laborCodeItem.description ?? "NA"}
                </div>
                <label className="px-2 d-flex align-items-center" style={{ borderRight: "1px solid #d1d1d1" }}>
                  <input
                    className="me-2"
                    type="checkbox"
                    defaultChecked={laborCodeItem.isTaxable}
                    onChange={() => {
                      productsData[index].laborCodesArr[itemIndex].isTaxable = !laborCodeItem.isTaxable;
                      setProductsData(productsData);
                    }}
                  />
                  Taxable
                </label>
                <Button
                  variant="outline-light"
                  onClick={() => {
                    setProductsData(
                      productsData.map((p) =>
                        p.id === product.id
                          ? {
                              ...p,
                              laborCodesArr: p.laborCodesArr.filter((lc) => lc.laborCode !== laborCodeItem.laborCode),
                              selectedLaborCodes: p.selectedLaborCodes.filter((lc) => lc !== laborCodeItem.laborCode),
                            }
                          : p,
                      ),
                    );
                  }}
                >
                  <img src={deleteIconBlue} alt="delete" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="d-flex justify-content-between">
        <Button variant="outline-primary" onClick={() => navigate(`/siteRepo/site/${siteId}`)}>
          Back
        </Button>
        <Button variant="primary" className="me-0" onClick={() => setStage("confirmation")} disabled={nextDisabled}>
          Next
        </Button>
      </div>

      {isShowAddProductModal && (
        <Modal
          title="Add Product"
          handleCancel={() => setIsShowAddProductModal(false)}
          size="xl"
          sectionName={""}
          closeButtonText="Cancel"
          rootClass="add-product-modal"
        >
          <ProductLookup
            currentProduct={selectedProduct}
            onProductSelectionCallback={onProductSelection}
            isHideSearchAfterSelection={true}
          />
        </Modal>
      )}
    </>
  );
};

export default BulkUpdateSite;
